import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { QualifierValue } from './QualifierValue';
/**
 * @summary SDK
 * @memberOf SDK
 */

var Qualifier = /*#__PURE__*/function () {
  function Qualifier(key, qualifierValue) {
    _classCallCheck(this, Qualifier);

    this.delimiter = '_'; // {key}{delimiter}{qualifierValue}

    this.key = key;

    if (qualifierValue instanceof QualifierValue) {
      this.qualifierValue = qualifierValue;
    } else {
      this.qualifierValue = new QualifierValue();
      this.qualifierValue.addValue(qualifierValue);
    }
  }

  _createClass(Qualifier, [{
    key: "toString",
    value: function toString() {
      var key = this.key,
          delimiter = this.delimiter,
          qualifierValue = this.qualifierValue;
      return "".concat(key).concat(delimiter).concat(qualifierValue.toString());
    }
  }, {
    key: "addValue",
    value: function addValue(value) {
      this.qualifierValue.addValue(value);
      return this;
    }
  }]);

  return Qualifier;
}();

export { Qualifier };